import { ref } from "vue";
import ProjectService, { PROJECT_CONSTANT } from "../services/projectService.js";

// Module-level singleton — shared between the Projects view and the side
// panel's "all projects" browsing mode, so opening either warms the other.
const projects = ref([]);
const isLoading = ref(false);
const isLoadingMore = ref(false);
const hasMore = ref(true);
let cursor = null;
let hasLoadedOnce = false;
let lastSortBy = "LAST_MODIFIED";
let lastSortDirection = "DESC";

const projectService = new ProjectService();

export function useProjectsList() {
  async function ensureLoaded() {
    if (hasLoadedOnce) return;
    hasLoadedOnce = true;
    isLoading.value = true;
    await loadMore();
    isLoading.value = false;
  }

  async function loadMore() {
    if (!hasMore.value || isLoadingMore.value) return;
    isLoadingMore.value = true;
    try {
      const res = await projectService.getProjects({
        projectType: PROJECT_CONSTANT.PROJECT_TYPES.ALL,
        projectsCursor: cursor,
        sortBy: lastSortBy,
        sortDirection: lastSortDirection,
      });
      projects.value.push(...(res.projects ?? []));
      cursor = res.endCursor;
      hasMore.value = res.hasNextPage;
    } finally {
      isLoadingMore.value = false;
    }
  }

  // Sort is applied server-side, so changing it re-fetches from scratch.
  async function resort(sortBy, sortDirection) {
    lastSortBy = sortBy;
    lastSortDirection = sortDirection;
    projects.value = [];
    cursor = null;
    hasMore.value = true;
    hasLoadedOnce = true;
    isLoading.value = true;
    await loadMore();
    isLoading.value = false;
  }

  return { projects, isLoading, isLoadingMore, hasMore, ensureLoaded, loadMore, resort };
}
